export default __webpack_public_path__ + "static/media/rs_raceweek_Austin_cochemoto_330x330.e7c90426.webp";